
export const mockReplies = [
  // 投稿1: 「今日も疲れた...」への返信
  {
    id: 'reply-101',
    post_id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
    user_id: 'user-011',
    content: 'わかります...本当にお疲れ様です。私も同じような毎日です。一人じゃないですよ。',
    created_at: '2025-01-15T11:00:00Z',
    profiles: {
      nickname: 'あやめママ',
      avatar_url: 'https://public.readdy.ai/ai/img_res/df48907b9da5143c62932f82e797c4ca.jpg',
      user_type: 'user' as const,
    },
  },
  {
    id: 'reply-102',
    post_id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
    user_id: 'user-012',
    content: '夜中の吸引、本当に大変ですよね。うちは夫と交代制にしてから少し楽になりました。無理しないでくださいね。',
    created_at: '2025-01-15T11:30:00Z',
    profiles: {
      nickname: 'つばきママ',
      avatar_url: 'https://readdy.ai/api/search-image?query=kind%20japanese%20mother%20early%2030s%20gentle%20expression%20portrait%20photo%20natural%20light%20soft%20background%20casual%20style&width=100&height=100&seq=avatar12&orientation=squarish',
      user_type: 'user' as const,
    },
  },
  {
    id: 'reply-103',
    post_id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
    user_id: 'user-013',
    content: '限界って思う時ありますよね。でもそう思えるのは頑張ってる証拠。自分を褒めてあげてください！',
    created_at: '2025-01-15T12:15:00Z',
    profiles: {
      nickname: 'なでしこママ',
      avatar_url: 'https://readdy.ai/api/search-image?query=caring%20japanese%20mother%20mid%2030s%20warm%20smile%20portrait%20photograph%20soft%20lighting%20cozy%20atmosphere&width=100&height=100&seq=avatar13&orientation=squarish',
      user_type: 'user' as const,
    },
  },
  {
    id: 'reply-104',
    post_id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
    user_id: 'user-014',
    content: 'レスパイト使ってますか？月に1回でも休む時間を作ると違いますよ。自治体に相談してみてください。',
    created_at: '2025-01-15T13:00:00Z',
    profiles: {
      nickname: 'かえでパパ',
      avatar_url: 'https://readdy.ai/api/search-image?query=friendly%20japanese%20father%20late%2030s%20gentle%20smile%20portrait%20photo%20casual%20clothes%20warm%20lighting&width=100&height=100&seq=avatar14&orientation=squarish',
      user_type: 'user' as const,
    },
  },
  {
    id: 'reply-105',
    post_id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
    user_id: 'user-015',
    content: '子どもの笑顔が力になりますよね。私もその笑顔に何度も救われました。一緒に頑張りましょう！',
    created_at: '2025-01-15T14:30:00Z',
    profiles: {
      nickname: 'すずらんママ',
      avatar_url: 'https://readdy.ai/api/search-image?query=cheerful%20japanese%20mother%20early%2030s%20bright%20smile%20portrait%20photo%20natural%20makeup%20light%20background&width=100&height=100&seq=avatar15&orientation=squarish',
      user_type: 'user' as const,
    },
  },
  {
    id: 'reply-106',
    post_id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
    user_id: 'partner-003',
    content: '毎日本当にお疲れ様です。介護疲れは蓄積します。訪問看護やヘルパーさんの利用時間を増やせないか、相談支援専門員に相談してみてください。ご自身の健康も大切にしてくださいね。',
    created_at: '2025-01-15T15:00:00Z',
    profiles: {
      nickname: '山田 由美',
      avatar_url: 'https://readdy.ai/api/search-image?query=professional%20japanese%20female%20nurse%20friendly%20smile%20portrait%20photo%20medical%20uniform%20clean%20background&width=100&height=100&seq=avatar16&orientation=squarish',
      user_type: 'partner' as const,
      partner_role: '訪問看護師',
    },
  },

  // 投稿2: 「テープかぶれがひどくて...」への返信
  {
    id: 'reply-201',
    post_id: 'b2c3d4e5-f6a7-8901-bcde-f12345678901',
    user_id: 'user-016',
    content: 'うちも同じでした！キャビロンという皮膚保護剤を使い始めてから、かなり改善しましたよ。',
    created_at: '2025-01-14T15:00:00Z',
    profiles: {
      nickname: 'ももママ',
      avatar_url: 'https://readdy.ai/api/search-image?query=gentle%20japanese%20mother%20mid%2030s%20kind%20expression%20portrait%20photo%20soft%20lighting%20warm%20tone&width=100&height=100&seq=avatar17&orientation=squarish',
      user_type: 'user' as const,
    },
  },
  {
    id: 'reply-202',
    post_id: 'b2c3d4e5-f6a7-8901-bcde-f12345678901',
    user_id: 'user-017',
    content: 'テープの種類を変えてみましたか？シリコンテープは肌に優しいのでおすすめです。',
    created_at: '2025-01-14T15:30:00Z',
    profiles: {
      nickname: 'うめパパ',
      avatar_url: 'https://readdy.ai/api/search-image?query=caring%20japanese%20father%20early%2040s%20warm%20smile%20portrait%20photo%20casual%20style%20natural%20light&width=100&height=100&seq=avatar18&orientation=squarish',
      user_type: 'user' as const,
    },
  },
  {
    id: 'reply-203',
    post_id: 'b2c3d4e5-f6a7-8901-bcde-f12345678901',
    user_id: 'user-018',
    content: 'リモイスコートを塗ってからテープを貼ると、剥がす時も肌への負担が少ないですよ！',
    created_at: '2025-01-14T16:00:00Z',
    profiles: {
      nickname: 'さつきママ',
      avatar_url: 'https://readdy.ai/api/search-image?query=friendly%20japanese%20mother%20late%2020s%20cheerful%20smile%20portrait%20photo%20bright%20background&width=100&height=100&seq=avatar19&orientation=squarish',
      user_type: 'user' as const,
    },
  },
  {
    id: 'reply-204',
    post_id: 'b2c3d4e5-f6a7-8901-bcde-f12345678901',
    user_id: 'user-019',
    content: 'テープを貼る位置を少しずつずらすようにしています。同じ場所に貼り続けないのがポイントです。',
    created_at: '2025-01-14T16:45:00Z',
    profiles: {
      nickname: 'あおいママ',
      avatar_url: 'https://readdy.ai/api/search-image?query=kind%20japanese%20mother%20mid%2030s%20gentle%20smile%20portrait%20photograph%20soft%20background&width=100&height=100&seq=avatar20&orientation=squarish',
      user_type: 'user' as const,
    },
  },
  {
    id: 'reply-205',
    post_id: 'b2c3d4e5-f6a7-8901-bcde-f12345678901',
    user_id: 'user-020',
    content: '皮膚科で相談したら、ステロイド軟膏を処方してもらえました。ひどい時は受診をおすすめします。',
    created_at: '2025-01-14T17:30:00Z',
    profiles: {
      nickname: 'はなパパ',
      avatar_url: 'https://readdy.ai/api/search-image?query=supportive%20japanese%20father%20mid%2030s%20warm%20expression%20portrait%20photo%20casual%20clothes&width=100&height=100&seq=avatar21&orientation=squarish',
      user_type: 'user' as const,
    },
  },
  {
    id: 'reply-206',
    post_id: 'b2c3d4e5-f6a7-8901-bcde-f12345678901',
    user_id: 'user-021',
    content: 'デュオアクティブという創傷被覆材を下に貼ってからテープを貼る方法もありますよ。',
    created_at: '2025-01-14T18:00:00Z',
    profiles: {
      nickname: 'みずきママ',
      avatar_url: 'https://readdy.ai/api/search-image?query=caring%20japanese%20mother%20early%2030s%20soft%20smile%20portrait%20photo%20natural%20lighting&width=100&height=100&seq=avatar22&orientation=squarish',
      user_type: 'user' as const,
    },
  },
  {
    id: 'reply-207',
    post_id: 'b2c3d4e5-f6a7-8901-bcde-f12345678901',
    user_id: 'user-022',
    content: '剥がす時にリムーバーを使うと肌への負担が減りますよ。3Mのリムーバーがおすすめです。',
    created_at: '2025-01-14T18:30:00Z',
    profiles: {
      nickname: 'ゆずママ',
      avatar_url: 'https://readdy.ai/api/search-image?query=gentle%20japanese%20mother%20late%2030s%20kind%20smile%20portrait%20photo%20warm%20background&width=100&height=100&seq=avatar23&orientation=squarish',
      user_type: 'user' as const,
    },
  },
  {
    id: 'reply-208',
    post_id: 'b2c3d4e5-f6a7-8901-bcde-f12345678901',
    user_id: 'partner-004',
    content: 'テープかぶれは多くの方が悩まれています。対策としては①皮膚保護剤の使用②シリコンテープへの変更③貼る位置のローテーション④剥離剤の使用があります。赤みがひどい場合は皮膚科受診をおすすめします。訪問看護師にも相談してみてくださいね。',
    created_at: '2025-01-14T19:00:00Z',
    profiles: {
      nickname: '鈴木 真理子',
      avatar_url: 'https://readdy.ai/api/search-image?query=professional%20japanese%20female%20nurse%20mid%2040s%20confident%20smile%20portrait%20photo%20medical%20setting&width=100&height=100&seq=avatar24&orientation=squarish',
      user_type: 'partner' as const,
      partner_role: '皮膚・排泄ケア認定看護師',
    },
  },

  // 投稿3: 「保育園探しで心が折れそう」への返信（既存）
  {
    id: 'reply-001',
    post_id: 'c3d4e5f6-a7b8-9012-cdef-123456789012',
    user_id: 'user-004',
    content: '私も同じ経験しました。最終的に認可外保育園で受け入れてもらえました。諦めないでください！',
    created_at: '2025-01-13T10:30:00Z',
    profiles: {
      nickname: 'たんぽぽママ',
      avatar_url: 'https://readdy.ai/api/search-image?query=warm%20japanese%20mother%20early%2030s%20encouraging%20smile%20portrait%20photo%20soft%20lighting&width=100&height=100&seq=avatar1&orientation=squarish',
      user_type: 'user' as const,
    },
  },
  {
    id: 'reply-002',
    post_id: 'c3d4e5f6-a7b8-9012-cdef-123456789012',
    user_id: 'user-005',
    content: '自治体の障害児保育担当課に相談してみましたか？うちの地域では専門の相談員がいて、受け入れ可能な園を紹介してくれました。',
    created_at: '2025-01-13T11:15:00Z',
    profiles: {
      nickname: 'すみれパパ',
      avatar_url: 'https://readdy.ai/api/search-image?query=supportive%20japanese%20father%20mid%2030s%20kind%20expression%20portrait%20photo%20casual%20style&width=100&height=100&seq=avatar2&orientation=squarish',
      user_type: 'user' as const,
    },
  },
  {
    id: 'reply-003',
    post_id: 'c3d4e5f6-a7b8-9012-cdef-123456789012',
    user_id: 'user-006',
    content: '保育園見学の時、看護師さんがいるか、医療的ケアの研修を受けているかを確認するといいですよ。',
    created_at: '2025-01-13T12:00:00Z',
    profiles: {
      nickname: 'あじさいママ',
      avatar_url: 'https://readdy.ai/api/search-image?query=friendly%20japanese%20mother%20late%2030s%20helpful%20smile%20portrait%20photo%20natural%20light&width=100&height=100&seq=avatar3&orientation=squarish',
      user_type: 'user' as const,
    },
  },
  {
    id: 'reply-004',
    post_id: 'c3d4e5f6-a7b8-9012-cdef-123456789012',
    user_id: 'user-007',
    content: '給食の対応も重要です。経管栄養の場合、どう対応してくれるか事前に確認しました。',
    created_at: '2025-01-13T13:30:00Z',
    profiles: {
      nickname: 'ゆりママ',
      avatar_url: 'https://readdy.ai/api/search-image?query=caring%20japanese%20mother%20mid%2030s%20thoughtful%20expression%20portrait%20photo%20soft%20background&width=100&height=100&seq=avatar4&orientation=squarish',
      user_type: 'user' as const,
    },
  },
  {
    id: 'reply-005',
    post_id: 'c3d4e5f6-a7b8-9012-cdef-123456789012',
    user_id: 'user-008',
    content: '園庭の広さや段差も見ておくといいです。車椅子やバギーでの移動がスムーズかチェックしました。',
    created_at: '2025-01-13T14:45:00Z',
    profiles: {
      nickname: 'ばらパパ',
      avatar_url: 'https://readdy.ai/api/search-image?query=helpful%20japanese%20father%20early%2040s%20warm%20smile%20portrait%20photo%20casual%20clothes&width=100&height=100&seq=avatar5&orientation=squarish',
      user_type: 'user' as const,
    },
  },
  {
    id: 'reply-006',
    post_id: 'c3d4e5f6-a7b8-9012-cdef-123456789012',
    user_id: 'user-009',
    content: '認可保育園がダメでも、認可外や企業主導型保育園という選択肢もあります。うちは企業主導型で受け入れてもらえました。',
    created_at: '2025-01-13T15:20:00Z',
    profiles: {
      nickname: 'きくママ',
      avatar_url: 'https://readdy.ai/api/search-image?query=encouraging%20japanese%20mother%20mid%2030s%20bright%20smile%20portrait%20photo%20light%20background&width=100&height=100&seq=avatar6&orientation=squarish',
      user_type: 'user' as const,
    },
  },
  {
    id: 'reply-007',
    post_id: 'c3d4e5f6-a7b8-9012-cdef-123456789012',
    user_id: 'user-010',
    content: '一時預かりから始めて、徐々に慣れていくという方法もありますよ。',
    created_at: '2025-01-13T16:00:00Z',
    profiles: {
      nickname: 'もみじママ',
      avatar_url: 'https://readdy.ai/api/search-image?query=gentle%20japanese%20mother%20late%2020s%20soft%20smile%20portrait%20photo%20warm%20tone&width=100&height=100&seq=avatar7&orientation=squarish',
      user_type: 'user' as const,
    },
  },
  {
    id: 'reply-008',
    post_id: 'c3d4e5f6-a7b8-9012-cdef-123456789012',
    user_id: 'partner-002',
    content: '保育士の立場からお伝えします。医療的ケア児の受け入れには、看護師配置や職員研修など準備が必要です。断られても、それは園の準備不足であって、お子さんのせいではありません。受け入れ実績のある園や、自治体の支援制度を活用してください。応援しています。',
    created_at: '2025-01-13T17:30:00Z',
    profiles: {
      nickname: '佐藤 恵子',
      avatar_url: 'https://readdy.ai/api/search-image?query=professional%20japanese%20female%20childcare%20worker%20mid%2040s%20warm%20smile%20portrait%20photo%20nursery%20setting&width=100&height=100&seq=avatar8&orientation=squarish',
      user_type: 'partner' as const,
      partner_role: '保育士',
    },
  },

  // 投稿4: 「【看護師より】冬の感染症対策」への返信
  {
    id: 'reply-401',
    post_id: 'd4e5f6a7-b8c9-0123-def1-234567890123',
    user_id: 'user-023',
    content: 'とても参考になります！加湿器の掃除頻度についても教えていただけますか？',
    created_at: '2025-01-12T17:00:00Z',
    profiles: {
      nickname: 'りんごママ',
      avatar_url: 'https://readdy.ai/api/search-image?query=curious%20japanese%20mother%20early%2030s%20interested%20expression%20portrait%20photo%20soft%20lighting&width=100&height=100&seq=avatar25&orientation=squarish',
      user_type: 'user' as const,
    },
  },
  {
    id: 'reply-402',
    post_id: 'd4e5f6a7-b8c9-0123-def1-234567890123',
    user_id: 'user-024',
    content: '訪問者への対応、悩んでいました。具体的なルールを決めておくと安心ですね。',
    created_at: '2025-01-12T17:30:00Z',
    profiles: {
      nickname: 'いちごパパ',
      avatar_url: 'https://readdy.ai/api/search-image?query=thoughtful%20japanese%20father%20mid%2030s%20gentle%20smile%20portrait%20photo%20casual%20style&width=100&height=100&seq=avatar26&orientation=squarish',
      user_type: 'user' as const,
    },
  },
  {
    id: 'reply-403',
    post_id: 'd4e5f6a7-b8c9-0123-def1-234567890123',
    user_id: 'user-025',
    content: '去年RSウイルスで入院したので、今年は特に気をつけています。この情報、助かります！',
    created_at: '2025-01-12T18:00:00Z',
    profiles: {
      nickname: 'みかんママ',
      avatar_url: 'https://readdy.ai/api/search-image?query=grateful%20japanese%20mother%20late%2030s%20warm%20smile%20portrait%20photo%20natural%20light&width=100&height=100&seq=avatar27&orientation=squarish',
      user_type: 'user' as const,
    },
  },
  {
    id: 'reply-404',
    post_id: 'd4e5f6a7-b8c9-0123-def1-234567890123',
    user_id: 'user-026',
    content: '手洗いのタイミング、改めて確認できてよかったです。ケア前後は特に意識します。',
    created_at: '2025-01-12T18:30:00Z',
    profiles: {
      nickname: 'ぶどうママ',
      avatar_url: 'https://readdy.ai/api/search-image?query=attentive%20japanese%20mother%20mid%2030s%20focused%20expression%20portrait%20photo%20soft%20background&width=100&height=100&seq=avatar28&orientation=squarish',
      user_type: 'user' as const,
    },
  },
  {
    id: 'reply-405',
    post_id: 'd4e5f6a7-b8c9-0123-def1-234567890123',
    user_id: 'user-027',
    content: '兄弟がいる場合の対策も知りたいです。上の子が風邪をもらってくることが多くて...',
    created_at: '2025-01-12T19:00:00Z',
    profiles: {
      nickname: 'めろんパパ',
      avatar_url: 'https://readdy.ai/api/search-image?query=concerned%20japanese%20father%20early%2040s%20thoughtful%20expression%20portrait%20photo%20warm%20tone&width=100&height=100&seq=avatar29&orientation=squarish',
      user_type: 'user' as const,
    },
  },
  {
    id: 'reply-406',
    post_id: 'd4e5f6a7-b8c9-0123-def1-234567890123',
    user_id: 'partner-001',
    content: 'ご質問ありがとうございます！加湿器は毎日水を入れ替え、週1回はタンクを洗浄してください。兄弟がいる場合は、帰宅後すぐの手洗い・うがいを習慣化し、体調が悪い時は可能な限り部屋を分けることをおすすめします。',
    created_at: '2025-01-12T20:00:00Z',
    profiles: {
      nickname: '田中 美咲',
      avatar_url: 'https://readdy.ai/api/search-image?query=professional%20japanese%20female%20nurse%20early%2030s%20friendly%20smile%20portrait%20photo%20medical%20uniform%20clean%20background&width=100&height=100&seq=avatar30&orientation=squarish',
      user_type: 'partner' as const,
      partner_role: '看護師',
    },
  },
  // 投稿4への追加パートナー返信（小児科医）
  {
    id: 'reply-407',
    post_id: 'd4e5f6a7-b8c9-0123-def1-234567890123',
    user_id: 'partner-005',
    content: '小児科医の立場から補足させていただきます。RSウイルスやインフルエンザの流行期は、シナジス（RSウイルス予防薬）の接種対象かどうか主治医に確認してください。また、家族全員のインフルエンザワクチン接種も重要な予防策です。お子さんの体調変化のサインを見逃さないよう、日頃から観察を続けてくださいね。',
    created_at: '2025-01-12T21:00:00Z',
    profiles: {
      nickname: '高橋 健一',
      avatar_url: 'https://readdy.ai/api/search-image?query=professional%20japanese%20male%20pediatrician%20doctor%20mid%2040s%20kind%20smile%20portrait%20photo%20white%20coat%20medical%20setting%20clean%20background&width=100&height=100&seq=avatar31&orientation=squarish',
      user_type: 'partner' as const,
      partner_role: '小児科医',
    },
  },
];
